import { AppStateWithData } from "../../../../AppStateWithData";
import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { FileAttachment, Message, UserProfile } from "../../../../../models";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";

interface NewSavedMessageRequest {
    chatUId: string
    sender: UserProfile
    messageText: string
    attachments: FileAttachment[]
    tempId?: string
}

export interface PostSavedMessageAdditionalData {
    chatUId: string
}

export const postSavedMessageActionTypes = createRequestActionTypes('CREATE_SAVED_MESSAGE')

const prepareSavedMessageRequest = async (chatUId: string, messageText: string, sender: UserProfile, constructAttachments: Promise<FileAttachment[]>, tempId: string): Promise<NewSavedMessageRequest> => {
    const attachments = await constructAttachments
    return {
        attachments,
        chatUId,
        messageText,
        sender,
        tempId
    }
}

export const postSavedMessage = (config: ApiConfig) => (chatUId: string, messageText: string, sender: UserProfile, constructAttachments: Promise<FileAttachment[]>, tempId: string) =>
    (dispatch: Dispatch, getState: () => AppStateWithData) => {
        const thunkParams: RequestThunkParameters<Message, NewSavedMessageRequest, PostSavedMessageAdditionalData> = {
            method: 'POST',
            requestActionTypes: postSavedMessageActionTypes,
            url: `${config.API_URL}/chat/addmessage`,
            asyncPrepareBody: prepareSavedMessageRequest(chatUId, messageText, sender, constructAttachments, tempId),
            actionAdditionalData: {
                chatUId
            },
        }
        return dispatch<any>(createRequestThunk(thunkParams))
    }